angular.module("menus")

    .controller("MenusItemsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("MENU_WRITE");

        $rootScope.title = $filter('translate')('menus.menu_options');
        $scope.menu_item = {
            FK_menus_items_permissions: []
        };
        $scope.menu_id = $stateParams.menu_id;

        $scope.selectParentMenu = {};

        $rootScope.breadcrumb = [
                { title: $filter('translate')('menus.menu_list'), url: "menus.list" },
                { title: $filter('translate')('menus.title'), url: "menus.edit({ id: " + $stateParams.menu_id + " })" },
        ];

        if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
            Restangular.one('MenusItems', $stateParams.id).get().then(function (results) {
                $scope.menu_item = results;

            });
        }

        Restangular.all('Permissions').getList().then(function (results) {
            $scope.selectPermissions = results;
            var permissionNull = {
                id: null,
                name: $filter('translate')('menus.no_permission')
            }
            $scope.selectPermissions.unshift(permissionNull);
        });

        var options: any = {}
        options.menu_id = $stateParams.menu_id;

        Restangular.all('MenusItems/GetSelectParentsMenu').getList(options).then(function (results) {
            $scope.selectParentMenusItems = results;
            var itemNull = {
                id: null,
                name: $filter('translate')('menus.no_father')
            }
            $scope.selectParentMenusItems.unshift(itemNull);
        });


        $scope.saveMenuItem = function () {
            if (angular.isDefined($scope.menu_item.FK_menus_items_permissions) && $scope.menu_item.FK_menus_items_permissions != null) $scope.menu_item.permission_id = $scope.menu_item.FK_menus_items_permissions.id;
            if ($scope.menu_item.permission_id == 0) $scope.menu_item.permission_id = null;
            if ($scope.menu_item.parent_menu_item_id == 0) $scope.menu_item.parent_menu_item_id = null;

            $scope.menu_item.menu_id = $scope.menu_id;

            if (!angular.isUndefined($scope.menu_item.id)) {
                $scope.menu_item.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('menus.edit_success'));
                        $state.go("menus.edit", { id: $scope.menu_item.menu_id });
                    }
                });
            } else {
                Restangular.all('menusItems').post($scope.menu_item).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('menus.create_success'));
                        $state.go("menus.edit", { id: $scope.menu_item.menu_id });
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('menus.button_delete'),
                message: $filter('translate')('menus.delete_message') + " " + $scope.menu_item.name + "?",
                onAccept: function () {
                    $scope.menu_item.remove().then(function () {
                        toastr.success($filter('translate')('menus.delete_success'));
                        $state.go("menus.edit", { id: $scope.menu_item.menu_id });
                    });
                }
            });
        };

    }]);